<template>
    <v-container fluid>   
      <v-layout row wrap>        
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="personnelPerformanceCriterias"
            :items-per-page="50"
            item-key="validityFrom"
            sort-by="validityFrom"
            :sort-desc="true"
            class="elevation-1"
            :search="search"
            :custom-filter="filterOnlyCapsText"
            hide-default-footer
            >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Performance Criteria History</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="900px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">New Performance Criteria</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12 sm6 md6>
                            <DatePicker picker-label="Valid From" :date-value="editedItem.validityFrom" @dateSelected="editedItem.validityFrom=$event" />
                          </v-flex> 
                          <v-flex xs12 sm6 md6>
                            <DatePicker picker-label="Valid Until" :date-value="editedItem.validityUntil" @dateSelected="editedItem.validityUntil=$event" />
                          </v-flex>                           
                          <v-flex xs12 sm6 md6>
                            <v-combobox
                            :items="performanceCriterias"
                            label="Select Performance Criteria"
                            v-model="editedItem.criteria"
                            item-text="text"
                            single-line
                            return-object
                          ></v-combobox>
                          </v-flex>                                                                                                                                                                                                                         
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                      <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
              <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
            </template> 
            <template v-slot:body.append>                    
            </template>             
            <template v-slot:item.action="{ item }">              
              <v-icon                  
                @click="editItem(item)">
                mdi-table-edit
              </v-icon>
              <v-icon                  
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
</template>
<script>
import formatPrice from '../helpers/formatter';
import DatePicker from '../components/DatePicker';
const API_URL = 'definitions/';
const PERSONNEL_API_URL = 'definitions/personnel/';
const CURRENCIES_API_URL = 'definitions/currencies';

export default {
    name : 'PersonnelPerformanceCriterias',
    props: {
    },
    components:{
      DatePicker
    },
    data () {
    return {
      dialog: false,
      search: '', 
      performanceCriterias: [],
      personnelPerformanceCriterias: [],   
      editedIndex: -1,
      editedItem: {
        criteria : ''
      },
      defaultItem: {},
    }
  },
  computed: {
    headers () {
      return [
        { text: 'Valid From', align: 'center', sortable: true, value: 'validityFrom' },
        { text: 'Valid Until', align: 'center', sortable: true, value: 'validityUntil' },
        { text: 'Performance Criteria', value: 'criteria.text' },
        { text: 'Actions', value: 'action', sortable: false },
      ]
    },         
    formTitle () {
      return this.editedIndex === -1 ? 'New Performance Criteria' : 'Edit Performance Criteria'
    },
  },
  created() {    
    this.getPerformanceCriterias();
    this.getPerformanceCriteriaHistory();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.personnelPerformanceCriterias.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },      
    deleteItem(item) {
      if(confirm('Are you sure you want to delete this item?')){
        this.deletePerformanceCriteria(item);
      } 
    },
    getPerformanceCriteriaHistory(){     
      this.$axios.get(this.$apiurl + PERSONNEL_API_URL+this.$route.params.id+'/performanceCriterias')
          .then(response => {
              this.personnelPerformanceCriterias = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    }, 
    getPerformanceCriterias(){     
      this.$axios.get(this.$apiurl + API_URL+'criterias')
          .then(response => {
              this.performanceCriterias = response.data
          }) 
          .catch(error => {
              console.log(error);
          });                         
    },
    save () {
      if (this.editedIndex > -1) {        
        this.updatePerformanceCriteria(this.editedItem);
      } else {
        this.addPerformanceCriteria(this.editedItem);         
      }      
    },
    addPerformanceCriteria(item){
      this.$axios.post(this.$apiurl + API_URL+'personnelPerformanceCriterias', {
        id : -1,
        personnelId : this.$route.params.id,
        validityFrom: item.validityFrom,
        validityUntil: item.validityUntil,
        criteriaId: item.criteria.id
      })
      .then(response => {        
        if (response.status === 201) {
          this.personnelPerformanceCriterias.push(this.editedItem);            
          this.close();         
          this.$radio.$emit('success', {message:'Personnel Performance Criteria Added Successfully'});
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },      
    updatePerformanceCriteria(item){
      this.$axios.put(this.$apiurl + API_URL+'personnelPerformanceCriterias', {
        id: item.id,
        personnelId : this.$route.params.id,
        validityFrom: item.validityFrom,
        validityUntil: item.validityUntil,
        criteriaId: item.criteria.id
      })
      .then(response => {
        if (response.status === 200) {
          Object.assign(this.personnelPerformanceCriterias[this.editedIndex], this.editedItem);            
          this.close();
          this.$radio.$emit('success', {message:'Personnel Performance Criteria Updated Successfully'});
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },      
    deletePerformanceCriteria(item){
      this.$axios.delete(this.$apiurl + API_URL+'personnelPerformanceCriterias/'+item.id)
      .then(response => {
        if (response.status === 200) {
          const index = this.personnelPerformanceCriterias.indexOf(item)
          this.personnelPerformanceCriterias.splice(index, 1);
          this.$radio.$emit('success', {message:'Personnel Performance Criteria Deleted Successfully'});
        }
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },            
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },           
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
